import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import moment from "moment"
import PlanningScreen from "../../screen/PlanningScreen"
import Send from "../../core/communication"
import { customToast } from "../../components/Toast"

export const formatTimestampToDate = (timestamp) => {
  const str = timestamp?.toString()?.slice(0, -3)
  return moment.unix(parseInt(str)).format("YYYY-MM-DD")
}

const updateArrayById = (array, id, updatedObject) => {
  const newArray = array?.map((item) => {
    if (item.id === id) {
      return updatedObject
    }
    return item
  })

  return newArray
}

const formatCard = ({
  id,
  name,
  list,
  description,
  tags,
  checklists,
  status,
  due_date,
  start_date,
  comments,
  creator,
  folder,
}) => ({
  id,
  list,
  status,
  title: name,
  description,
  tags,
  checklists,
  comments,
  creator,
  folder,
  due_date: formatTimestampToDate(due_date),
  start_date: formatTimestampToDate(start_date),
})

const formatStatusOldProjects = (status) => {
  switch (status) {
    case "aberto":
      return "em aberto";
    case "andamento":
      return "em andamento";
    case "complete":
      return "concluídas";
    default:
      return status;
  }
};

const formattedLanes = (data) => {
  if (!Array.isArray(data) || !data?.length) return []

  const lanesFixed = [
    {
      id: "backlog",
      title: "Backlog",
      cards: [],
      label: 0,
    },
    {
      id: "em aberto",
      title: "Em aberto",
      cards: [],
      label: 0,
    },
    {
      id: "em andamento",
      title: "Em andamento",
      cards: [],
      label: 0,
    },
    {
      id: "para validação",
      title: "Para Validação",
      cards: [],
      label: 0,
    },
    {
      id: "concluídas",
      title: "Finalizadas",
      cards: [],
      label: 0,
    },
  ]

  const tasks = data.map(({ tasks }) => tasks).flat()

  tasks.forEach((task, i) => {
    const lane = lanesFixed.find((lane) => lane.id === formatStatusOldProjects(task?.status?.status))
    if (lane) {
      lane.cards.push(task)
      lane.label = 1 + i++
    } else {
      console.error(`Nenhuma lista corresponde à tarefa ${task.id}`)
    }
  })

  return {
    lanes: lanesFixed.map((lane) => ({
      id: lane.id,
      title: lane.title,
      label: lane.label,
      cards: lane.cards.map(formatCard),
    })),
  }
}

const initialStateFormat = {
  data: {},
  foldersData: [],
  reload: false,
  clickedCard: {},
  status: {},
  modalOpenDetails: false,
  values: {
    description: "",
    comment: "",
    commentCreator: "",
    checkList: "",
    checkListItems: {},
    checkListItemName: "",
    checkListItem: "",
  },
  showCommentAdd: "",
  showNewCheckListItem: "",
  showNewCheckListItemItem: "",
  checked: [],
}

const initialLoading = {
  loadingLists: false,
  loadingBoards: false,
  loadingTask: false,
  loadingComment: false,
  loadingComments: false,
  loadingChecklist: false,
}

const PlanningContainer = () => {
  const [initialState, setInitialState] = useState(initialStateFormat)
  const [loading, setStateLoading] = useState(initialLoading)
  const loggedUser = useSelector((state) => state.app?.user?.user)
  const [filteredLists, setFilteredLists] = useState([]);

  const {
    data,
    foldersData,
    reload,
    clickedCard,
    status,
    modalOpenDetails,
    values,
    showCommentAdd,
    showNewCheckListItem,
    showNewCheckListItemItem,
    checked,
  } = initialState

  const { loadingLists, loadingBoards, loadingTask, loadingComment, loadingComments, loadingChecklist } = loading

  const loadBoards = async () => {
    try {
      setStateLoading((prevState) => ({ ...prevState, loadingBoards: true }))
      const response = await Send.get(`/impactools/folders/all`)
      setInitialState((prevState) => ({ ...prevState, foldersData: response }))
      return response
    } catch (error) {
      setInitialState((prevState) => ({ ...prevState, foldersData: [] }))
      console.log("Erro ao retornar quadros")
    } finally {
      setStateLoading((prevState) => ({ ...prevState, loadingBoards: false }))
    }
  }

  const loadLists = async (folderId) => {
    if (folderId) {
      try {
        setStateLoading((prevState) => ({ ...prevState, loadingLists: true }))
        const response = await Send.get(`/impactools/folder/${folderId}/lists`)
        setInitialState((prevState) => ({
          ...prevState,
          listData: response,
          onlyLists: response.map(row => ({ value: row.id, label: row.name })),
          data: formattedLanes(response),
        }))
      } catch (error) {
        setInitialState((prevState) => ({ ...prevState, listData: [] }))
        console.log("Erro ao retornar commentários", error)
      } finally {
        setInitialState((prevState) => ({ ...prevState, reload: false }))
        setStateLoading((prevState) => ({ ...prevState, loadingLists: false }))
      }
    }
  }

  const loadComments = async (taskId) => {
    if (taskId) {
      try {
        setStateLoading((prevState) => ({ ...prevState, loadingComments: true }))
        const response = await Send.get(`/impactools/task/${taskId}/comments`)
        setInitialState((prevState) => ({
          ...prevState,
          clickedCard: {
            ...prevState.clickedCard,
            comments: response?.comments,
          },
        }))
      } catch (error) {
        console.log("Erro ao retornar commentários", error)
      } finally {
        setInitialState((prevState) => ({ ...prevState, reload: false }))
        setStateLoading((prevState) => ({ ...prevState, loadingComments: false }))
      }
    }
  }

  useEffect(() => {
    loadBoards()
  }, [])

  useEffect(() => {
    if (foldersData?.length > 0) {
      setInitialState((prevState) => ({
        ...prevState,
        values: { ...values, foldersData: foldersData[0]?.id },
      }))
    }
  }, [foldersData])

  useEffect(() => {
    if (values?.foldersData !== "") {
      loadLists(values?.foldersData)
    }
  }, [values?.foldersData, reload])

  useEffect(async () => {
    if (!modalOpenDetails) {
      setInitialState((prevState) => ({
        ...prevState,
        values: {
          ...prevState.values,
          commentCreator: "",
        },
        clickedCard: {},
        showCommentAdd: "",
      }))
    }
    else {
      loadComments(clickedCard?.id)
    }
    
  }, [modalOpenDetails])

  const onChangeStatus = (item) => {
    setInitialState((prevState) => ({ ...prevState, status: item }))
  }

  const onChange = (field, value, id) => {
    if (id) {
      setInitialState((prevState) => ({
        ...prevState,
        values: {
          ...prevState.values,
          [field]: {
            ...prevState?.values[field],
            [`${field}-${id}`]: value,
          },
        },
      }))
    } else {
      setInitialState((prevState) => ({
        ...prevState,
        values: {
          ...prevState.values,
          [field]: field === "foldersData" ? value?.value : value,
        },
      }))
    }
  }

  const openModalTaskDetails = async (data) => {
    setInitialState((prevState) => ({ ...prevState, modalOpenDetails: true, clickedCard: data }))

    const { description, due_date, start_date, status, checklists } = data

    const resolvedItems = checklists.map((checklist) =>
      checklist.items
        .filter((item) => item.resolved === true)
        .map((item) => `${item?.id}|${checklist?.id}`),
    )[0]

    setInitialState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        description,
        dueDate: due_date,
        startDate: start_date,
      },
      checked: resolvedItems,
    }))

    setInitialState((prevState) => ({
      ...prevState,
      status: {
        label: `${status?.status[0]?.toUpperCase()}${status?.status.slice(1)}`,
        color: status?.color,
      },
    }))
  }

  const handleUpdateTask = async (data) => {
    const { cardId, targetLaneId } = data

    try {
      setStateLoading((prevState) => ({ ...prevState, loadingTask: true }))
      const response = await Send.put(`/impactools/task/${clickedCard?.id || cardId}`, {
        status: values?.status?.label?.toLowerCase() || targetLaneId,
        due_date: moment(values?.dueDate).format("x"),
        start_date: moment(values?.startDate).format("x"),
      })

      if (Object.values(response).length > 0) {
        setInitialState((prevState) => ({
          ...prevState,
          reload: true,
        }))
      } else {
        customToast("Erro ao alterar tarefa", "erro")
      }
    } catch (error) {
      console.log(error)
    } finally {
      setStateLoading((prevState) => ({ ...prevState, loadingTask: false }))
    }
  }

  const handleCreateComment = async () => {
    try {
      setStateLoading((prevState) => ({ ...prevState, loadingComment: true }))
      const commentCreatorToSave = `${loggedUser?.name}|${values?.commentCreator}`

      const response = await Send.post(`/impactools/task/${clickedCard?.id}/comment`, {
        comment_text: commentCreatorToSave,
        assignee: clickedCard?.creator?.id,
        resolved: false,
      })

      if (response.status === "success") {
        setInitialState((prevState) => ({
          ...prevState,
          reload: true,
          showCommentAdd: "",
          values: { ...values, commentCreator: "" },
          clickedCard: {
            ...prevState.clickedCard,
            comments: response?.comment?.comments,
          },
        }))
      } else {
        customToast("Ocorreu um erro ao salvar o comentário, tente novamente", "error")
      }
    } catch (error) {
      customToast(error, "error")
      console.log(error)
    } finally {
      setStateLoading((prevState) => ({ ...prevState, loadingComment: false }))
      setInitialState((prevState) => ({ ...prevState, reload: false }))
    }
  }

  const openEditOptions = (id, data) => {
    setInitialState((prevState) => ({
      ...prevState,
      showCommentAdd: id,
      values: { ...values, comment: data },
    }))
  }

  const openEditCheckListTitleItem = (id, data) => {
    setInitialState((prevState) => ({
      ...prevState,
      showNewCheckListItemItem: id,
      values: { ...values, checkListItemName: data },
    }))
  }

  const closeTextArea = () => {
    setInitialState((prevState) => ({
      ...prevState,
      showCommentAdd: "",
      values: { ...values, commentCreator: " " },
    }))
  }

  const closeTextAreaCheckList = () => {
    setInitialState((prevState) => ({
      ...prevState,
      showNewCheckListItemItem: "",
      showNewCheckListItem: "",
      values: { ...values, checkListName: "", checkListItem: "" },
    }))
  }

  const handleAddItemCheckList = (id) => {
    setInitialState((prevState) => ({
      ...prevState,
      showNewCheckListItem: id,
      values: { ...values, comment: data },
    }))
  }

  const handleCreateCheckListItem = async (id) => {
    try {
      setStateLoading((prevState) => ({ ...prevState, loadingChecklist: true }))
      const response = await Send.post(`/impactools/checklist/${id}/item`, {
        name: values?.checkListItem,
        assignee: 81992359,
      })

      if (response?.checklist && Object.values(response?.checklist).length > 0) {
        setInitialState((prevState) => ({
          ...prevState,
          reload: true,
        }))
        setInitialState((prevState) => ({
          ...prevState,
          reload: true,
          clickedCard: {
            ...clickedCard,
            checklists: updateArrayById(
              clickedCard?.checklists,
              response?.checklist?.id,
              response?.checklist,
            ),
          },
        }))
      } else {
        customToast("Ocorreu um erro ao salvar o item, tente novamente", "error")
      }
    } catch (error) {
      customToast(error, "error")
      console.log(error)
    } finally {
      setStateLoading((prevState) => ({ ...prevState, loadingChecklist: false }))
      setInitialState((prevState) => ({
        ...prevState,
        loadingChecklist: false,
        reload: false,
        showNewCheckListItem: "",
        values: { ...values, checkListName: "", checkListItem: "" },
      }))
    }
  }

  const handleCheckListItem = async (e) => {
    const { checked, value } = e.target
    setInitialState((prevState) => ({
      ...prevState,
      checked: checked
        ? [...prevState.checked, value]
        : prevState.checked.filter((val) => val !== value),
    }))

    if (initialState?.checked) {
      const response = await Send.put(
        `/impactools/checklist/${value?.split("|")[1]}/item/${value?.split("|")[0]}`,
        {
          resolved: checked ? true : false,
        },
      )
    }
  }

  const onDragEnd = async (cardId, sourceLaneId, targetLaneId) => {
    if (targetLaneId === sourceLaneId) return;

    try {
      const response = await Send.put(`/impactools/task/${cardId}`, {
        status: targetLaneId,
      })

      if (Object.values(response).length > 0) {
        setInitialState((prevState) => ({ ...prevState, reload: true }))
      } else {
        customToast("Erro ao alterar tarefa", "erro")
      }
    } catch (error) {
      console.log(error)
    } finally {
      setInitialState((prevState) => ({ ...prevState, reload: false }))
    }
  }

  const handleSelectList = (values) => {
    setFilteredLists(values);
  }

  const applyListFilter = () => {
    let dataToReturn = data;

    if(filteredLists && filteredLists.length) {
      dataToReturn = {
        lanes: dataToReturn.lanes.map(row => {
          const filteredCards = row.cards.filter(item => filteredLists.find(list => list.value === item.list.id));

          return { ...row, cards: filteredCards, label: filteredCards.length };
        })
      }
    }

    return dataToReturn;
  }

  return (
    <>
      <PlanningScreen
        {...{
          loggedUser,
          data: applyListFilter(),
          listOptions: initialState.onlyLists || [],
          foldersData,
          loadingLists,
          loadingBoards,
          loadingTask,
          loadingChecklist,
          loadingComment,
          loadingComments,
          openModalTaskDetails,
          modalOpenDetails,
          setModalOpenDetails: (value) =>
            setInitialState((prevState) => ({ ...prevState, modalOpenDetails: value })),
          onChange,
          clickedCard,
          onChangeStatus,
          status,
          values,
          handleUpdateTask,
          handleCreateComment,
          openEditOptions,
          closeTextArea,
          closeTextAreaCheckList,
          showCommentAdd,
          showNewCheckListItem,
          showNewCheckListItemItem,
          openEditCheckListTitleItem,
          handleAddItemCheckList,
          handleCreateCheckListItem,
          handleCheckListItem,
          checked,
          onDragEnd,
          handleSelectList,
          filteredLists
        }}
      />
    </>
  )
}

export default PlanningContainer
